module.exports = __webpack_public_path__ + "images/mdj/members/resume/common/common_btn01-d172333673e1679f8f29edcc2abd3645.png";